import { render, staticRenderFns } from "./PaymentProofModal.vue?vue&type=template&id=5d4be682"
import script from "./PaymentProofModal.vue?vue&type=script&lang=js"
export * from "./PaymentProofModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentProofModal.vue?vue&type=style&index=0&id=5d4be682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports